export default function Node_Async() {
  return <div>Node_Async Component</div>;
}
